import { boot } from '../hooks/boot.hook';

export const routerConfig = {
  boot,
};
